import { Component, Inject, Input, AfterViewInit} from 'ng-metadata/core';
import {ImagesUtil} from '../../../nddUtils/ImagesUtil.service';
import {ResultUtil} from '../../../nddUtils/resultUtil.service';
import {BriefResultService} from '../../briefResult/briefResult.service';
import {isBrowserIE} from '../../../infra/browserSniffer';
import {PrimoResponse} from '../../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
import {SearchService} from "../../search.service";
import {SearchResultThumbnailContainerService} from "./searchResultThumbnailContainer.service";
import {getResouceTypeImages} from '../../../appConfig/customizationConfig';
interface Link {
    displayLabel: string;
}

@Component({
    providers: [ImagesUtil],
    selector: "prm-search-result-thumbnail-container",
    templateUrl: 'components/search/searchResult/searchResultThumbnail/search-result-thumbnail-container.html'
})

export class PrmSearchResultThumbnailContainer implements AfterViewInit {
    private selectedThumbnailLink: Object;
    private customThumbnailLink: Object;
    private lastPnxId = '-1';
    @Input() private frbr: Object;
    @Input() private isFrbrGeneric: boolean;
    @Input() private item: PrimoResponse.IDoc;
    @Input() private links: Link[];
    @Input() private pnxId: string;
    @Input() private isVirtualBrowse: boolean;
    @Input() private isFeaturedResult:boolean;


    constructor( @Inject('$http') private $http: ng.IHttpService,
        @Inject('$q') private $q: ng.IQService,
        private imagesUtil: ImagesUtil,
        private resultUtil: ResultUtil,
        private briefResultService: BriefResultService,
        @Inject('$state') private $state: angular.ui.IStateService,
        @Inject('$timeout') private $timeout: angular.ITimeoutService,
        private configurationUtil : ConfigurationUtil,
        private searchService: SearchService,
        private searchResultThumbnailContainerService: SearchResultThumbnailContainerService) {

        let type = this.searchResultThumbnailContainerService.getType(this.isFeaturedResult, this.item);
        let customThumbnail = {
            displayLabel: 'thumbnail',
            linkType: 'http://purl.org/pnx/linkType/thumbnail',
            linkURL: getResouceTypeImages()[type]
        };
        this.customThumbnailLink = customThumbnail;
    }

    public go() {


        let timeout = 0;

        if(this.configurationUtil.isSuprima()){
            timeout = isBrowserIE() ? 400 : 100;
        }
        this.$timeout(() => this.searchResultThumbnailContainerService.getThumbnailLinks(this.links, this.isFeaturedResult, this.frbr, this.isFrbrGeneric, this.isVirtualBrowse, this.item).then((selectedThumbnail) => {this.selectedThumbnailLink = selectedThumbnail}), timeout, false);
    }

    /**
    * This method uses asynchronous calls to enforce the following logic:
    * get all thumnails
    * try to fetch google
    * if no google try amazon
    * if no amazon - get all other thumbnails from the record
    * for Suprima - amazon won't be used. we will use syndetics instead
    * first link that succeeds - break with the link
    * in case of frbr we push the default icon for the type to the array to ensure that it will be used
    * in the frbr fan mode (for regular records we push the image in search-result-thumbnail-container.html)
    */

    public isMultipleVersions() {
        if(this.isFeaturedResult){
            return false;
        }
        return this.resultUtil.displayMultipleVersions(this.item, this.briefResultService.getSearchObject());
    }

    private getThumbnailFromAmazon(thumbnailLinks) {
        return this.$q((resolve) => {
            let amazonLink = thumbnailLinks.filter(this.searchResultThumbnailContainerService.getSpecificLink, 'amazon');
            if (amazonLink.length > 0) {
                this.imagesUtil.getImageLink(amazonLink[0]).then((promise) => {
                    resolve(promise);
                }, () => {
                    resolve('');
                });
            } else {
                resolve('');
            }
        });
    }

    isFavoriteState() {
        return this.searchResultThumbnailContainerService.isFavoriteState();
    }

    getResourceTypeForDisplay() {
        return (this.searchService.getFrbrDisplay() === 1 || !this.item ? 'mediatype.multiplever' : 'mediatype.'+this.item.pnx.display.type[0]);
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultThumbnail/searchResultThumbnailContainer.directive.ts